import React, { useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Select } from 'grommet';

import { getCustomerList, getCustomerFile } from '../../../../api';
import { PageWrapper, Badge, MigrationActions, Breadcrumbs, Pagination } from '../../../../components';
import { TableHeader, TableMessages, TableWrap, TableRow, TableCols, TableActionsCol } from '../../../../components/listing';

import { useOpenLayer, useFetchListing } from '../../../../hooks';

import { layers, pagination, messageDictionary } from '../../../../constants';

const SearchResult = () => {
  const { migrationId } = useParams();
  const [searchTerm, setSearchTerm] = useState('');
  const [ownerFilter, setOwnerFilter] = useState('');

  const { open } = useOpenLayer();

  const customerTypes = useMemo(() => [
    { id: '', name: 'Todos os clientes' },
    { id: 'true', name: 'Proprietarios' },
    { id: 'false', name: 'Interessados' },
  ], []);

  const filters = useMemo(() => ({
    ...(searchTerm && { search: searchTerm }),
    ...(ownerFilter && { owner: ownerFilter })
  }), [searchTerm, ownerFilter]);

  const {
    loading,
    list,
    requestError,
    page,

    onNavigate,
  } = useFetchListing({
    migrationId,
    get: getCustomerList,
    filters
  });

  return (
    <PageWrapper>
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        width: '100%'
      }}>
        <MigrationActions />
        <Breadcrumbs />
      </div>

      <TableWrap>
        <TableHeader
          title='Clientes'
          totalItens={list.total}

          download={{
            fileName: 'clientes.csv',
            resource: getCustomerFile,
          }}
        />

        <div className='table-filter'>
          <input
            type='search'
            placeholder='Buscar por nome ou email...'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className='table-filter__input'
          />

          <Select
            options={customerTypes}
            value={ownerFilter}
            labelKey='name'
            valueKey={{
              key: 'id',
              reduce: true,
            }}
            emptySearchMessage='Selecione um tipo'
            onChange={({ target }) => setOwnerFilter(target.value)}
            className='table-filter__select'
          />
        </div>

        {requestError && (
          <TableMessages message={messageDictionary.requestFail} />
        )}

        {loading && !requestError && (
          <TableMessages message={messageDictionary.waitingResponseRequest} />
        )}

        {!loading && !requestError && list.total <= 0 && (<TableMessages />)}

        {!loading && !requestError && list.data.map((row, index) => (
          <TableRow key={index}>
            <TableCols
              columns={[
                { width: 'small', value: row.name },
                { width: 'xsmall', value: <Badge text={row.owner ? 'Proprietário' : 'Interessado'} /> },
                { width: 'small', value: row.phones && row.phones.join(' ') },
                { width: 'medium', value: row.emails && row.emails.join(' ') }
              ]}
            />

            <TableActionsCol
              actions={[
                {
                  label: 'detalhes',
                  action: () => open({ entityIdentifier: row._id, layer: layers.detail }),
                }
              ]}
            />
          </TableRow>
        ))}
      </TableWrap>

      <Pagination
        totalOfRows={list.total}
        page={page}
        perPage={pagination.limit}
        onNavigate={onNavigate}
      />
    </PageWrapper>
  )
}

export default SearchResult;
